var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLasso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 0C128.943 0 0 78.797 0 176C0 244.851 64.842 304.305 159.105 333.226C193.186 345.254 216 376.555 216 412.031C216 458.344 177.344 496 129.812 496H40C35.578 496 32 499.594 32 504S35.578 512 40 512H129.812C186.156 512 232 467.156 232 412.031C232 386.308 221.836 362.5 204.889 344.484C231.217 349.328 259.088 352 288 352C447.059 352 576 273.203 576 176S447.059 0 288 0ZM288 336C138.02 336 16 264.223 16 176S138.02 16 288 16C437.982 16 560 87.777 560 176S437.982 336 288 336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLasso);
export default __webpack_public_path__ + "static/media/lasso.487c9d2ba6fe6a79cb81a5120bd887dc.svg";
export { ForwardRef as ReactComponent };